import { render, staticRenderFns } from "./pay-way.vue?vue&type=template&id=cdb26f9c&"
import script from "./pay-way.vue?vue&type=script&lang=js&"
export * from "./pay-way.vue?vue&type=script&lang=js&"
import style0 from "./pay-way.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports